export const logisticsManagementExplanation =
  'Indica si quieres automatizar la gestión logística a través de Reveni o gestionarlo manualmente. En cualquiera de los dos casos, indica también el servicio de logística que usarás para este método de devolución.'

export const pickUpPointsExplanation =
  'Este método de devolución utiliza puntos de recogida. En el Returns Portal, el cliente podrá elegir un punto de entrega y la etiqueta de devolución se generará para ese punto.'
